export default {
      id: "credentials-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#credentials",
      toString: function () {
        return this.url;
      }
    }